import { getStreamMeta, getStreamSessions } from "../../../common/src/stream";
import moment from "moment";
import { RECORD_STATUSES } from "../constants/common";
import { getEpisodeRecordStatus, getStreamRecordStatus } from "./stream-helper";

export const getEmbedEpisode = (episodeKey, streams) => {
    if (!episodeKey) return {};

    const stream = (streams || []).find(({ episode }) => episode.some(({ key }) => key === episodeKey));
    if (!stream) return {};

    const episode = stream.episode.find(({ key }) => key === episodeKey);
    const { isRecord } = getStreamMeta(stream);
    const isEpisodeRecord = getStreamRecordStatus(stream) === RECORD_STATUSES.EPISODES_CUT && getEpisodeRecordStatus(episode) === RECORD_STATUSES.EPISODES_CUT;
    const sessions = getStreamSessions(stream);

    return {
        episode,
        isEpisodeRecord,
        offset: (isRecord && !isEpisodeRecord) ? episode.timeStart - sessions[0].timeStart : 0,
        stream: { ...stream, episode: [episode] },
        playable: episode.timeStart <= moment().unix()
    }
}